import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWrenchTools = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M22 27L24.95 29.95C25.2759 30.2826 25.6648 30.5468 26.0941 30.7272C26.5234 30.9076 26.9844 31.0005 27.45 31.0005C27.9156 31.0005 28.3766 30.9076 28.8059 30.7272C29.2352 30.5468 29.6241 30.2826 29.95 29.95V29.95C30.2826 29.6241 30.5468 29.2352 30.7272 28.8059C30.9076 28.3766 31.0005 27.9156 31.0005 27.45C31.0005 26.9844 30.9076 26.5234 30.7272 26.0941C30.5468 25.6648 30.2826 25.2759 29.95 24.95L28 23",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.925 18.225L14.5 14.8",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.4 15.5L14.5 14.8L15.2 12.7L12.4 9.90002L9.59998 12.7L12.4 15.5Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.678 12.922L27.6 15.987L24.005 12.411L27.085 9.34499C26.3745 9.03694 25.5929 8.93072 24.826 9.03799C23.403 9.16021 22.0801 9.82008 21.1265 10.8833C20.1729 11.9465 19.6603 13.3332 19.693 14.761C19.6855 15.3223 19.7898 15.8795 20 16.4L10.145 25.083C9.80325 25.3877 9.52619 25.758 9.33025 26.1718C9.13432 26.5856 9.02351 27.0346 9.00439 27.4921C8.98527 27.9496 9.05823 28.4062 9.21895 28.835C9.37967 29.2637 9.62487 29.6558 9.94 29.988V29.988C10.2624 30.3252 10.6529 30.5899 11.0855 30.7646C11.5182 30.9392 11.983 31.0197 12.4492 31.0008C12.9153 30.9819 13.3721 30.864 13.7892 30.6548C14.2062 30.4457 14.574 30.1502 14.868 29.788L23.594 19.978C24.5266 20.2515 25.5075 20.3198 26.469 20.178C27.4822 19.9687 28.4191 19.4869 29.1788 18.7845C29.9385 18.0821 30.4921 17.1857 30.78 16.192C31.1073 15.1205 31.0714 13.971 30.678 12.922V12.922Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgWrenchTools);
export default ForwardRef;
